import React from "react";
import PropTypes from "prop-types";
import { Modal, Button, Form } from "react-bootstrap";

function AcceptRequestDialog({
  open,
  setReportReason,
  reportReason,
  onClose,
  onAccept,
  text = "",
  title = "Confirmation",
  cancelText = "Cancel",
  acceptText = "Accept",
  reportUser = false,
}) {
  return (
    <Modal show={open} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="text-center w-100">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {text && <p>{text}</p>}
        {reportUser && (
          <Form.Group controlId="reportReason">
            <Form.Label>Reason</Form.Label>
            <Form.Control
              type="text"
              value={reportReason}
              onChange={(e) => setReportReason(e.target.value)}
              placeholder="Enter reason"
              autoFocus
            />
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {cancelText}
        </Button>
        <Button variant="primary" onClick={onAccept}>
          {acceptText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

AcceptRequestDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setReportReason: PropTypes.func,
  reportReason: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  text: PropTypes.string,
  title: PropTypes.string,
  cancelText: PropTypes.string,
  acceptText: PropTypes.string,
  reportUser: PropTypes.bool,
};

export default AcceptRequestDialog;
